'use client';

import React from 'react';
import Image from 'next/image';

const Card = ({ className = '', title, img, ...props }) => {
  const baseClasses =
    'block max-w-[406px] bg-lime-400/10 backdrop-blur-sm border border-lime-400/50 p-8';

  return (
    <div className={`${baseClasses} ${className}`} {...props}>
      <div className="flex flex-col items-start space-y-6">
        <div className="w-[88px] h-[88px] bg-linear-41 from-[#9eff00]/50 from 22% to-[#9eff00]/0 to 71% border border-lime-400 rounded-xl flex items-center justify-center">
          <Image src={img} alt="Globe" width={40} height={40} />
        </div>
        <h3 className="text-2xl font-montserrat font-medium text-white leading-[33px] max-w-[300px]">
          {title}
        </h3>
      </div>
    </div>
  );
};

export default Card;
